import HubPage from "@/pages/HubPage";
import { B2B } from "@/seo/b2bContent";

export default function B2BPage() {
  return <HubPage id="b2b" content={B2B} metaKey="b2b" hero="/images/laser.jpg" bg="/images/sudura.jpg" />;
}
